import React, { useState } from 'react';
import { Stack } from '@mui/material';
import TopBar from '../../../components/TopBar';
import MeterListPageActions from '../components/MeterListPageActions';
import MetersTable from '../components/MetersTable';

export default function MeterListPage() {
  const [pagination, setPagination] = useState({ page: 0, size: 10 });
  const handlePaginationChange = (page, limit) => setPagination({ page, size: limit });

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <TopBar title="Meters">
        <MeterListPageActions />
      </TopBar>
      <MetersTable handlePaginationChange={handlePaginationChange} searchQuery={pagination} />
    </Stack>
  );
}
